import { request } from "@/utils/request";

export const retrieveDataBasedOnID = (id) => {
  return request.get(`/tf/retrieveDataBasedOnID?ID=${id}`);
};

export const targetRetrieveDataBasedOnID = (id) => {
  return request.get(`/target/retrieveDataBasedOnID?ID=${id}`);
};

export const cofRetrieveDataBasedOnID = (id) => {
  return request.get(`/tf/cofRetrieveDataBasedOnID?ID=${id}`);
};
